<template>
  <div>
    <feather-icon title="Edit" icon="EditIcon" svgClasses="h-6 w-6 hover:text-primary cursor-pointer" @click="editGamePopup()"/>
  </div>
</template>

<script>
import XLSX from 'xlsx';
export default {
  name: 'CellRendererGameEdit',
  data(){
    return {
      downloadType: 'exposcore'
    }
  },
  methods: {
    editGamePopup(){
      //this.params.data = true;
      this.$root.$emit('editGamePopup', this.params.data)
    },
  }
}
</script>
